import { Theme } from '@mui/material';
import { StyleRules } from '@mui/styles/withStyles';

const styles = (theme: Theme): StyleRules => ({
  noEventsAllowed: {
    pointerEvents: 'none',
  },
  skillsWrapper: {
    overflowY: 'auto',
    '& button': {
      margin: '10px 5px 0 0',
      cursor: 'pointer',
    },
  },
  selectedSkill: {
    marginTop: 16,
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2),
    lineHeight: 'normal',
  },
  selectIcon: {
    marginLeft: 5,
    fontSize: 20,
  },
});

export default styles; // Export the typed styles
